<template>
  <el-dialog title="完成处理" :visible.sync="dialogVisible" width="700px" append-to-body>
    <div class="process-completed-container">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="180px">
        <el-form-item label="处理完结：" prop="process_code">
          <el-radio-group v-model="form.process_code">
            <el-radio v-for="item in complaintStatusOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="回复平台：" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="5"  maxlength="1000" show-word-limit />
        </el-form-item>

        <el-form-item label="回复用户（对客展示）：" prop="reply_content">
          <el-input
            v-model="form.reply_content"
            type="textarea"
            :rows="3"
            placeholder="请勿出现辱骂、侮辱、违法等信息，一旦出现将永久封禁"
            maxlength="2048"
            show-word-limit
          />
        </el-form-item>

        <el-form-item label="留言图片：" >
          <el-upload
            v-model="form.img_file_list"
            :action="apiUrl"
            drag
            multiple
            accept="image/jpeg,image/png,image/jpg"
            list-type="picture-card"
            :data="extraData"
            :limit="10"
            :file-list="getStableImageFileList('img_file_list', form.img_file_list)"
            :headers="file_headers"
            :on-preview="questionPreview"
            :on-success="questionSuccess"
            :on-remove="questionRemove"
            :on-change="questionChange"
            :on-error="questionError"
            :on-exceed="questionExceed"
            :before-upload="beforeUpload"
          >
          <!-- 非必填，最多上传 10 张，支持jpg、png、ipeg，支持删除重新上传，默认为空，可编辑 -->
            <i v-if="form.img_file_list.length < 10" class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogImageVisible" width="500px" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
          <div class="upload-tooltip">
            最多上传10张，支持jpg,png,jpeg
          </div>
        </el-form-item>
      </el-form>
    </div>


    <div slot="footer" class="dialog-footer">
      <el-button type="default" size="small" @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" size="small" :loading="dialogloading" @click="onSubmit">确 认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import BASE_API from '@/config';
import { getToken } from '@/utils/localStorage.js';
import { handleZfbComplaintFinishApi } from '@/api/merchant_complain_handle';
import { appendImageInSelectionOrder, imageUploadMixin, removeImageByUploadFile } from '@/utils/imageUpload.js';

class DefaultForm {
  constructor () {
    this.id = undefined; // 商户号
    this.complain_id = undefined; // 投诉单主键ID
    this.process_code = '' // 处理完结状态
    this.remark = '';
    this.reply_content = '';
    this.img_file_list = [];
  }
}

export const complaintStatusOptions = [
  { label: '已退款，用户无异议', value: 'REFUND' },
  { label: '已通过其他渠道退款', value: 'OTHER_CHANNEL_REFUND' },
  { label: '不涉及退款，已针对投诉内容进行整改', value: 'RECTIFICATION_NO_REFUND' },
  { label: '已联系到用户，协商一致，无异议', value: 'CONSENSUS_WITH_CLIENT' },
  { label: '不认可举报的证明材料', value: 'SUBMIT_PROOF_NOT_CONTACTED' },
  { label: '其他', value: 'ORTHER' },
]


export default {
  name: 'ReplyUsers',
  mixins: [imageUploadMixin],
  data() {
    return {
      file_headers: {
        //头带当前用户信息
        Authorization: 'Bearer ' + getToken(),
      },
      apiUrl: BASE_API + 'admin/customer_complaint/alipay/file_upload',
      dialogVisible: false,
      form: new DefaultForm(),
      rules: {
        process_code: [
          { required: true, message: '请选择处理完结内容', trigger: 'change' }
        ],
        remark: [
        { required: true, message: '请输入回复平台', trigger: 'blur' }
        ],
        reply_content: [
          { required: true, message: '请输入回复用户内容', trigger: 'blur' },
          { max: 2048, message: '回复用户内容最多2048字', trigger: 'blur' }
        ]
      },
      dialogImageUrl: '',
      dialogImageVisible: false,
      dialogloading: false,

      complaintStatusOptions,
    };
  },
  computed: {
    extraData () {
      return {
        id: this.form.id
      }
    }
  },
  methods: {
    triggleVisible (data) {
      this.resetImageUploadScope('img_file_list')
      this.form = new DefaultForm()
      this.form.id = data.selectMerchantId
      this.form.complain_id = String(data.id)
      this.dialogVisible = true;
      this.$refs.formRef && this.$refs.formRef.resetFields()
    },

    questionPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogImageVisible = true;
    },

    beforeUpload (file) {
      const acceptFileTypes = ['image/jpeg', 'image/png', 'image/jpg']
      if (!acceptFileTypes.includes(file.type)) {
        this.$message.error('图片格式错误，支持jpg、png、jpeg');
        return false;
      }
      return true
    },

    questionChange(file, fileList) {
      this.trackImageUpload('img_file_list', file, fileList)
    },

    questionSuccess(response, file, fileList) {
      if (!this.isCurrentImageUpload('img_file_list', file)) return
      console.log('response', response)
      if (response.code != 200) {
        file.status = 'fail'
        this.trackImageUpload('img_file_list', file, fileList)
        this.$message.error(response.message);
      } else {
        this.$message.success('上传成功');
        this.form.img_file_list = appendImageInSelectionOrder(this.form.img_file_list, file, {
          ...response.data,
          url: response.data.file_url
        });
        this.trackImageUpload('img_file_list', file, fileList)
      }
    },

    questionRemove(file, fileList) {
      this.form.img_file_list = removeImageByUploadFile(this.form.img_file_list, file);
      this.removeTrackedImage('img_file_list', file, fileList)
    },

    questionError(error, file, fileList) {
      if (!this.isCurrentImageUpload('img_file_list', file)) return
      this.trackImageUpload('img_file_list', file, fileList)
      this.$message.error(`${file.name || '图片'}上传失败`)
    },

    questionExceed(files, fileList) {
      this.handleImageUploadExceed(10, files, fileList)
    },

    // 必填性校验
    handleValidateReleatedField () {
      // 回复平台字段remark, 除了 已退款，用户无异议 非必填之外，其他都必填
      const { process_code } = this.form
      // !['REFUND'].includes(process_code) && 
      if (!this.form.remark) {
        this.$message.error('请输入回复平台');
        return false;
      }

      // 留言图片，只有 已通过其他渠道退款 的时候必填
      if (['OTHER_CHANNEL_REFUND'].includes(process_code) && !this.form.img_file_list.length) {
        this.$message.error('请上传留言图片');
        return false;
      }

      return true;
    },

    onSubmit () {
      if (!this.guardImageUploads(['img_file_list'])) return
      this.$refs.formRef.validate((valid) => {
        if (valid && this.handleValidateReleatedField() !== false) {
          console.log('this.form', this.form)
          const params = {
            ...this.form,
            img_file_list: this.form.img_file_list.map(item => {
              return {
                img_url: item.file_url,
                img_url_key: item.file_key
              }
            })
          }
          console.log('params', params)
          this.dialogloading = true
          handleZfbComplaintFinishApi(params).then(res => {
            console.log('res', res)
            if (res.data.code == 200) {
              this.$emit('success')
              this.$message.success('处理成功');
              this.dialogVisible = false;
            } else {
              this.$message.error(res.message);
            }
          }).catch(() => {
            // 全局拦截器负责展示服务端校验错误，弹窗保留以便删减图片重试。
          }).finally(() => {
            this.dialogloading = false
          });
        }
      });
    }
  }
};

</script>

<style lang="scss" scoped>
.process-completed-container {
  .el-radio {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
